import { render, staticRenderFns } from "./e-organization-user-notifications-status-icon.vue?vue&type=template&id=2502c7f8&scoped=true&lang=pug"
import script from "./e-organization-user-notifications-status-icon.vue?vue&type=script&lang=js"
export * from "./e-organization-user-notifications-status-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502c7f8",
  null
  
)

export default component.exports